<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Counter
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Counter Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Counter Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 v-if="user.roleName === 'ADMIN' || user.roleName === 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="counterList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.shopName }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>
                      {{
                        props.item.updatedDateInMilliSeconds
                          | format-ms-date-time
                      }}
                    </td>
                    <td>{{ props.item.updatedBy }}</td>
                    <td>
                      <v-icon
                        v-if="props.item.status == 'ACTIVE'"
                        medium
                        color="green"
                        >check_circle</v-icon
                      >
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                    <td>
                      <v-btn
                        flat
                        icon
                        color="blue lighter-2"
                        @click="onEdit(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { counterService } from "../../services/counter-service";
import { shopService } from "../../services/shop-service";
export default {
  name: "CounterList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Counter",
        disabled: true,
      },
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Shop", align: "left", value: "shopName" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status" },
      { text: "Action", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    counterList: [],
    shopList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    queryParams: {
      name: "",
      code: "",
      shopId: "",
      status: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getCounterList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.user.roleName == "ADMIN" || this.user.roleName == "BRANCH_ADMIN") {
      this.getShopList();
    }
    if (this.user.roleName == "SALE_MANAGER") {
      this.queryParams.shopId = this.user.shopId;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "counters", query: this.queryParams });
      this.getCounterList();
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCounterList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      counterService
        .getCounterList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.counterList = res.data.counterList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      //go to detail page
      this.$router.push("/counter/new");
    },
    onEdit(counter) {
      //go to detail page
      this.$router.push("/counter/" + counter.id);
    },
  },
};
</script>
